import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
const Signup = () => {
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would register with a backend
    navigate('/onboarding');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-118">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-119">
        <h2 className="text-center text-3xl font-extrabold text-gray-900" data-id="element-120">
          LucaGet
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-121">
          Create your supplier account
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-122">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-123">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-124">
            <div data-id="element-125">
              <label htmlFor="business-name" className="block text-sm font-medium text-gray-700" data-id="element-126">
                Business Name
              </label>
              <div className="mt-1" data-id="element-127">
                <input id="business-name" name="business-name" type="text" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-128" />
              </div>
            </div>
            <div data-id="element-129">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-130">
                Email address
              </label>
              <div className="mt-1" data-id="element-131">
                <input id="email" name="email" type="email" autoComplete="email" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-132" />
              </div>
            </div>
            <div data-id="element-133">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-134">
                Password
              </label>
              <div className="mt-1" data-id="element-135">
                <input id="password" name="password" type="password" autoComplete="new-password" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-136" />
              </div>
            </div>
            <div data-id="element-137">
              <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700" data-id="element-138">
                Confirm Password
              </label>
              <div className="mt-1" data-id="element-139">
                <input id="confirm-password" name="confirm-password" type="password" autoComplete="new-password" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-140" />
              </div>
            </div>
            <div className="flex items-center" data-id="element-141">
              <input id="terms" name="terms" type="checkbox" required className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-142" />
              <label htmlFor="terms" className="ml-2 block text-sm text-gray-900" data-id="element-143">
                I agree to the{' '}
                <a href="#" className="text-blue-600 hover:text-blue-500" data-id="element-144">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="#" className="text-blue-600 hover:text-blue-500" data-id="element-145">
                  Privacy Policy
                </a>
              </label>
            </div>
            <div data-id="element-146">
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-147">
                Sign up
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-148">
            <div className="relative" data-id="element-149">
              <div className="absolute inset-0 flex items-center" data-id="element-150">
                <div className="w-full border-t border-gray-300" data-id="element-151" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-152">
                <span className="px-2 bg-white text-gray-500" data-id="element-153">
                  Already have an account?
                </span>
              </div>
            </div>
            <div className="mt-6" data-id="element-154">
              <Link to="/login" className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-155">
                Sign in
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Signup;